import React from "react";

import { AttributeCardDisplayVariantType } from "../types";

import AttributeSelectionCard from "@/Components/PersonalAttributes/Components/AttributeSelectionCard";
import { type AppUserSession } from "@/schemas/auth/session";
import {
  Height,
  UserHeightAttributeSet,
} from "@/schemas/profile/attributes/UserHeightAttributeSet";
import type { AttributeValue } from "@/schemas/attribute/AttributeSet";

type HeightProps = {
  session: AppUserSession;
  heightValue: Height | null;
  variant: AttributeCardDisplayVariantType;
};

function HeightSelection({
  session,
  heightValue,
  variant,
}: HeightProps): React.JSX.Element {
  const values = heightValue ? [UserHeightAttributeSet.map[heightValue]] : [];
  const typedValues = values.filter(
    (item): item is AttributeValue => item !== undefined,
  );

  return (
    <AttributeSelectionCard
      session={session}
      attribute={UserHeightAttributeSet}
      values={typedValues}
      icon={"📏"}
      variant={variant}
    />
  );
}

export default HeightSelection;
